import { kebabCase, snakeCase } from 'lodash-es'

import { EntityName } from './const'

export const entityIdParam = (name: string) => `${snakeCase(name)}_id`
export const entityDetailsPermalink = (name: string) =>
  name === EntityName.LIST ? 'segment-details' : `${kebabCase(name)}-details`
